import { fromJS } from 'immutable'

import {
  CONFIG_JSON_GET,
  CONFIG_JSON_UPDATE,
  CONFIG_JSON_ERROR,
  META_GET,
  META_UPDATE,
  META_ERROR,
  NAVIGATION_FORWARD,
  NAVIGATION_SET,
  HEADER_SHOW,
  HEADER_UPDATE,
  HEADER_CLEAR,
  SKIP_SHOW,
  SKIP_CLEAR,
  USER_DATA_UPDATE,
} from 'actions/general'

// Reducer
// ---------------------------------------------------------------------------

export const initialState = fromJS({
  configJSON: null,
  meta: null,
  orgslug: null,
  username: null,
  email: null,
  portalUrl: null,
  navigationIndex: 0,
  header: {
    available: false,
    data: null,
  },
  skip: false,
  loading: {
    configJSON: false,
    meta: false,
  },
  error: {
    configJSON: false,
    meta: false,
  },
})

export default function generalReducer(state = initialState, action) {
  switch (action.type) {
    case CONFIG_JSON_GET:
      return _getConfigJson(state)
    case CONFIG_JSON_UPDATE:
      return _updateConfigJson(state, action.payload)
    case CONFIG_JSON_ERROR:
      return _errorConfigJson(state, action.payload)
    case META_GET:
      return _getMeta(state)
    case META_UPDATE:
      return _updateMeta(state, action.payload)
    case META_ERROR:
      return _errorMeta(state, action.payload)
    case NAVIGATION_FORWARD:
      return _navigationForward(state, action.payload)
    case NAVIGATION_SET:
      return _navigationSet(state, action.payload)
    case HEADER_SHOW:
      return _showHeader(state)
    case HEADER_UPDATE:
      return _updateHeader(state, action.payload)
    case HEADER_CLEAR:
      return _clearHeader(state)
    case SKIP_SHOW:
      return _showSkip(state, action.payload)
    case SKIP_CLEAR:
      return _clearSkip(state)
    case USER_DATA_UPDATE:
      return _updateUserData(state, action.payload)
    default:
      return state
  }
}

const _getConfigJson = state => {
  return state.updateIn(['loading', 'configJSON'], () => true)
}

const _updateConfigJson = (state, payload) => {
  const {
    auth: { user: { username } = { username: false } },
  } = payload.data
  return state
    .set('username', username || state.get('username'))
    .set('configJSON', fromJS(payload.data))
    .updateIn(['loading', 'configJSON'], () => false)
    .updateIn(['error', 'configJSON'], () => false)
}

const _errorConfigJson = (state, payload) => {
  return state
    .setIn(['error', 'configJSON'], payload.error)
    .updateIn(['loading', 'configJSON'], () => false)
}

const _getMeta = state => {
  return state.updateIn(['loading', 'meta'], () => true)
}

const _updateMeta = (state, payload) => {
  return state
    .set('meta', fromJS(payload.data))
    .updateIn(['loading', 'meta'], () => false)
    .updateIn(['error', 'meta'], () => false)
}

const _errorMeta = (state, payload) => {
  return state
    .setIn(['error', 'meta'], payload.error)
    .updateIn(['loading', 'meta'], () => false)
}

const _navigationForward = (state, payload) => {
  return state.update('navigationIndex', value => value + 1)
}

const _navigationSet = (state, payload) => {
  return state.set('navigationIndex', payload.index)
}

const _showHeader = state => {
  return state.updateIn(['header', 'available'], () => true)
}

const _updateHeader = (state, payload) => {
  return state.mergeIn(['header'], payload)
}

const _clearHeader = state => {
  return state
    .updateIn(['header', 'data'], () => null)
    .updateIn(['header', 'available'], () => false)
}

const _showSkip = state => {
  return state.update('skip', () => true)
}

const _clearSkip = state => {
  return state.update('skip', () => false)
}

const _updateUserData = (state, payload) => {
  return state
    .set('orgslug', payload.orgslug || state.get('orgslug'))
    .set('portalUrl', payload.portalUrl || state.get('portalUrl'))
    .set('email', payload.email || state.get('email'))
}
